function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

function setCookie(name, value, options = {}) {
  var optionsDefault = {
    path: '/',
    domain: document.domain,
    // add other defaults here if needed
  };
  options = Object.assign({}, optionsDefault, options);

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  } else {
    const date = new Date()
    date.setMonth(date.getMonth() + 1)
    options.expires = date.toUTCString();
  }

  var updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

  for (var optionKey in options) {
    updatedCookie += "; " + optionKey;
    var optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }

  document.cookie = updatedCookie;
}

function setLocaleCookie() {
  const currentLocale = window.location.href.split('/')[3].substring(0,2);
  setCookie('_qonto-locale', currentLocale);
}
setLocaleCookie();

function setFinanceadsCookie() {
  const currentLocale = window.location.href.split('/')[3].substring(0,2);
  const financeadsId = getUrlParameter('s_id');

  if (financeadsId.length && currentLocale == 'it') {
    setCookie('_qonto-s-id', financeadsId);
  }
}
setFinanceadsCookie();

function setUtmCookie() {
  if (utmParamsOrQCampaign()) {
    setCookie('_qonto-utm', JSON.stringify(compactedOverridedUtm()));
  }
}
setUtmCookie();

function compactedUtm() {
  const UTM_KEYS = [
    "utm_source",
    "utm_campaign",
    "utm_medium",
    "utm_term",
    "utm_content"
  ];

  var hash = {}
  UTM_KEYS.map(function(key) {
    hash[key] = getUrlParameter(key)
  })
  Object.keys(hash).forEach((k) => (hash[k] == null || hash[k] == '') && delete hash[k]);

  return hash
};

function compactedOverridedUtm() {
  if (!QCampaignAndNoUtmCampaign()) return compactedUtm();
  const overrided_utm = compactedUtm();
  overrided_utm.utm_campaign = getUrlParameter('q_campaign');
  return overrided_utm;
};

function utmParamsOrQCampaign() {
  return (Object.keys(compactedUtm()).length || QCampaignAndNoUtmCampaign())
};

function QCampaignAndNoUtmCampaign() {
  return (getUrlParameter('q_campaign').length && !compactedUtm().hasOwnProperty('utm_campaign'))
};

function setReferralCookie() {
  if ((window.location.href.indexOf("/r/") > -1)) {
    var expires = new Date()
    expires.setMonth(expires.getMonth() + 6)
    var referral_code = window.location.pathname.split('/')[3];
    setCookie('_qonto-referral-code', referral_code, {expires: expires});
  }
};
setReferralCookie();

export {
  getCookie
};
